import {useMatchMedia} from '@pexip/hooks';

import {MD_UP} from '../../constants/mediaQueries';

export const useMdUp = () => useMatchMedia(MD_UP);
